import { onBeforeUnmount, ref } from 'vue'
import { useRouter } from 'vue-router'

/**
 * useRouterProgress — tracks whether a navigation is in flight.
 *
 * Sets `isNavigating` to true on `beforeEach` and back to false on
 * `afterEach`/`onError`. Because the router's beforeEach guards await session
 * and store loads, the flag stays true for the whole guard duration — which
 * is exactly the window where the user is waiting on the router.
 */
export function useRouterProgress() {
  const router = useRouter()
  const isNavigating = ref(false)

  const start = () => {
    isNavigating.value = true
  }
  const stop = () => {
    isNavigating.value = false
  }

  const removeBefore = router.beforeEach(start)
  const removeAfter = router.afterEach(stop)
  const removeError = router.onError(stop)

  onBeforeUnmount(() => {
    removeBefore()
    removeAfter()
    removeError()
  })

  return { isNavigating }
}
